import React, { useEffect } from "react";
import {
    Divider,
    Box,
    // Tooltip,
    // IconButton,
    Checkbox,
} from "@mui/material";
import Title from '../../sharedcomponents/title/title';
import RouteConstants from "../../constants/routeConstants";
// import IOSOnOffSwitch from '../../sharedcomponents/switchComponent/IOSOnOffSwitch';
import APIURLConstants from '../../config/config';
import Helper from '../../utility/helper';
import ApiHelper from '../../utility/ApiHelper';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import ButtonContainer from "../../sharedcomponents/buttoncontainer/buttonContainer";
import { createState, useState } from '@hookstate/core';
import { generatePath, useHistory } from "react-router-dom";
// import { useAgentState } from "../../hookState/AgentState";

const settingSate = createState({
    isEmail: true,
    isPush: true,
    isBlast: true,
    NotificationSettingID:0
});

const Settings = () => {
    const state = useState(settingSate);
    const history = useHistory();

    // const [toggle, setToggle] = React.useState(false)
    // const [notificationData, setNotificationData] = React.useState()

    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    // const agentState = useAgentState();

    useEffect(() => {
        getAppNotifications()
    }, []);
    const getAppNotifications = () =>
    {
        const userInfo = Helper.getStorage('userInfo');
        const eventInfo = Helper.getStorage('eventInfo');
        const gAgentInfo=Helper.getStorage('agentUser');
                const agentConnection = Helper.getStorage('agentConnections');
        ApiHelper.get(APIURLConstants.GET_USER_NOTIFICATION_SETTING(eventInfo.eventID, agentConnection && gAgentInfo? gAgentInfo.userID:userInfo.userID))
            .then((res) => {
                // console.log(res.data)
                // setNotificationData(res.data)
                state.set({
                    isEmail: res.data.isEmail,
                    isPush: res.data.isPush,
                    isBlast: res.data.isBlast,
                    NotificationSettingID: res.data.NotificationSettingID
                })
            })
    };
    // const getAppNotificationCount = () =>
    // {
    //     const userInfo = Helper.getStorage('userInfo');
    //     let markIds = [];
    //     ApiHelper.get(
    //         APIURLConstants.GET_APP_NOTIFICATION_COUNT(userInfo.userID)
    //     )
    //         .then((res) =>
    //         {
    //             markIds.push({ notificationCount: res.data });
    //         })
    //         .catch((err) =>
    //         {
    //             console.log(err);
    //         });
    // };
    const handleClose = () => {
        const eventInfo = Helper.getStorage('eventInfo');
        const path = generatePath(RouteConstants.EVENT_DETAIL, { 'eventID': eventInfo.eventID });
        history.push({
            pathname: path, 
        });
    }
    const handleSubmit = (e) => {
        console.log(e);
        // setToggle(e.target.checked)
        const userInfo = Helper.getStorage('userInfo');
        const eventInfo = Helper.getStorage('eventInfo');

        const requestObj = {  
            NotificationSettingID: state.get().NotificationSettingID,
            userID: userInfo.userID,
            connectionID: userInfo.userID,
            eventID: eventInfo.eventID,
            isEmail: state.get().isEmail,
            isPush: state.get().isPush,
            isBlast: state.get().isBlast,
            createdBy: userInfo.userID,
            userIDs:"",
            isAdmin:false,
        }
        ApiHelper.post(APIURLConstants.SAVE_APP_NOTIFICATION_SETTING, requestObj)
            .then((res) => {
                // console.log(res.data)
                if (res.data) {
                    setSnackBarProps({
                        snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Notification Updated Successfully',
                    })
                }
                getAppNotifications()
                // window.location.reload()
            })
    }
    return (
        < >
            <Box
                className="contentBox"
                style={{ paddingLeft: '24px', paddingRight: '24px' }}>
                <Box  >
                    <Title title="App Notifications" />
                    <Box
                        component="form"
                        sx={{
                            width: '100%',
                        }}>
                        <Box>
                            <Checkbox
                                onChange={(e) => state.set({ ...state.get(), isEmail: e.target.checked })}
                                checked={state.get().isEmail}
                            /> Enable Email Notification
                        </Box>
                        <Box sx={{ width: '100%', marginTop: 1 }}>
                            <Checkbox
                                onChange={(e) => state.set({ ...state.get(), isPush: e.target.checked })}
                                checked={state.get().isPush}
                            /> Enable Mobile Notification
                        </Box>
                        <Box sx={{ width: '100%', marginTop: 1 }}>
                            <Checkbox
                                onChange={(e) => state.set({ ...state.get(), isBlast: e.target.checked })}
                                checked={state.get().isBlast}
                            /> Enable App Notification
                        </Box>
                    </Box>
                    <Box component="div">
                        {/* <Box sx={{ width: '100%' }}>
                        </Box> */}
                        <Divider
                            light={false}
                            sx={{ mt: 2, marginRight: 0, mb: 2 }}
                            flexItem
                        />
                        <ButtonContainer
                            showLoading={true}
                            // loading={isLoading}
                            handleClick={handleSubmit}
                            handleCancel={handleClose}
                            buttonText={'Update'}
                        />
                    </Box>
                    {snackBarProps.openSnack && (
                        <CustomizedSnackbars
                            {...snackBarProps}
                            onClose={() =>
                                setSnackBarProps({ ...snackBarProps, openSnack: false })
                            }></CustomizedSnackbars>
                    )}
                </Box>

            </Box>
        </>
    )
}
export default {
    routeProps: {
        path: RouteConstants.SETTINGS,
        component: Settings,
    },
    name: 'Settings',
}